import React, { useContext, useState } from "react";
import { SidebarContext } from "context/SidebarContext";
import VendorServices from "services/VendorServices";
import { notifySuccess } from "utils/toast";
import ConfirmVendorModal from "components/form/ConfirmVendorModel";

const VendorStatus = ({
  id,
  isActive,
  isBlocked,
  title_block = "Vendor",
}) => {
  const { setIsUpdate, setFunctionLoading } = useContext(SidebarContext);
  const [showBlockModal, setShowBlockModal] = useState(false);

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id || 0;

  // Determine current status: 0 = Inactive, 1 = Active, 2 = Blocked
  const currentStatus = isBlocked === 1 ? 2 : isActive === 1 ? 1 : 0;

  // const handleChangeStatus = () => {
  //   setShowBlockModal(true);
  // };

  const handleChangeStatus = () => {
  // When Active → Inactive / Block → need remarks
  if (currentStatus === 1) {
    setShowBlockModal(true);
  } else {
    // When Inactive or Blocked → Active → show modal without remarks
    setShowBlockModal(true);
  }
};

  const handleUpdateBlock = async (remark, goStatus) => {
    setShowBlockModal(false);
    setFunctionLoading(true);

    const statusNum = Number(goStatus); // 0 (inactive), 1 (active), 2 (blocked)

    // Map status number to action string
    let action = "";
    if (statusNum === 0) action = "inactive";
    else if (statusNum === 1)
      // action = currentStatus === 2 ? "unblock" : "active";
      action =  "active";
    else if (statusNum === 2) action = "block";

    try {
      await VendorServices.updateVendorStatus(id, {
        // status: statusNum,
        // deactive_remark: remark,
        // action_by: id_employee,
        // action,
        // remark,
        type:action,
        remark:remark
      });

      notifySuccess(`${title_block} status updated successfully`);
      setIsUpdate(true);
    } catch (err) {
      console.error("Error updating vendor status:", err);
    } finally {
      setFunctionLoading(false);
    }
  };

  // Define options dynamically based on current status
  const getStatusOptions = () => {
    if (currentStatus === 1) {
      // Active: can go to Inactive or Block
      return [
        { value: "0", label: "Inactive" },
        { value: "2", label: "Block" },
      ];
    } else if (currentStatus === 0) {
      // Inactive: can go to Active
      return [{ value: "1", label: "Active" }];
    } else if (currentStatus === 2) {
      // Blocked: can go to Unblock (same as Active)
      return [{ value: "1", label: "Unblock" }];
    }
    return [];
  };

  return (
    <>
      <span
        className="text-sm cursor-pointer text-blue-500 focus:outline-none"
        style={{ fontSize: "11px" }}
        onClick={handleChangeStatus}
      >
        Change
      </span>
      <ConfirmVendorModal
        isOpen={showBlockModal}
        status={currentStatus}
        statusOptions={getStatusOptions()}
        onClose={() => setShowBlockModal(false)}
        onConfirm={handleUpdateBlock}
        showRemark={currentStatus === 1}
      />
    </>
  );
};

export default VendorStatus;
